import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      loading: false,
    };
  },

  props: {
    onSubmit: {
      type: Function,
      required: true,
      default: () => {},
    },
    info: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  computed: {
    //
  },

  mounted() {
    // console.log(this.info);
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    run() {
      this.loading = true;
      this.onSubmit()
      .then(() => {
        this.loading = false;
        this.$message({
          showClose: true,
          message: this.$t('static.organizationSettings.bulk_price_update_success'),
          type: 'success',
        });
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
    },

    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
      this.onClose();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/bulkPriceUpdatePopup/bulkPriceUpdatePopup.js